
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm online-bhupaal-panshikar section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> सितार वादन कोरोना को संघर्ष देने वाले सभी<br><span >योद्धाओं के प्रोत्साहन अवं
                    धन्यवाद् हेतु</span></h2>
            <p>By</p>
            <p>Shri. Bhupaal Panshikar</p>
            <p>(भारत रत्न श्री रविशंकरजी तथा पं दिनकर पणशीकर, जयपुर घराना, इनके शिष्य)</p>
        </div>
        <div class="row mt-5">
            <div class="col-lg-8">
                <div class=" text-justify">
                    <h2 class="head-lea">SHRI. BHUPAL PANSHIKAR <span class="small-sm">13 MAY 2020 </span></h2>
                    <p>Bhupal is a Sitar player and singer, composer Bhupal Panshikar is a singular figure in Indian
                        Classical music Diasporas whose eminent style of sitar playing has regaled audiences in India
                        and abroad.</p>
                    <p>Coming from a family of Sanskrit literature stalwarts, drama, and music personalities young
                        Bhupal chose to study music at the tender age of 10 under his father and guru pt.Dinkar
                        Panshikar (living legend of Jaipur gharana). Bhupal really has a gifted musical persona right
                        from childhood resulting, he enacted in the fabulous Marathi musical play katyar kaljat Ghusli
                        as a child artist way back in 1983-84.
                        In his early teens Bhupal started learning sitar from Bharat Ratna lt Pt.Ravishankar ji in Delhi
                        and then padmabhushan pt. Arvind Parikh (well-known maestro of vilayatkhani gharana) and till
                        the date receiving training from him.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-bhupal.webp"
                        alt="GHRSCF">
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <p>A quest for more musical knowledge made him more studious towards vocal tradition of north Indian Music
                (stylistic singing) and studied under lt.pt.chandrashekhar rele a well-known associate and gurubandhu of
                lt.pt.kumar gandharwa of Gwalior gharana. Simultaneously Bhupal’s sitar is influenced by his own vocal
                training and a tremendous impact of vocal phrases woven in his playing resulting it going beyond sheer
                tonal music.</p>
            <p>Bhupal is a composer and music arranger and has worked with many Bollywood composers and has been
                actively playing sitar for film industry, daily soap operas, and Back Ground Music scores for various
                titles. His first solo album Raga Sangraha 1 & 2 successfully captured music lovers in 2010</p>
        </div>
        <div class="">
            <h6 class="fw-bold">MAIN COMPOSER OF SOUL CURRY FLAMENCO AND JAZZ FUSION BAND</h6>
            <ul class="list-style list-style1">
                <li>Pan IIT Global Leadership Summit –California –USA2015</li>
                <li>Prathswar –innitiative by Panchamnishad creatives –Mumbai2016</li>
                <li>Saptak – Nasik2007</li>
                <li>Indian music Festival- Germany and Hongkong2005</li>
                <li>Indian music fest strings and tones –USA 2017</li>
                <li>Potpourri international ensemble –Singapore Feb. 2018</li>
                <li>Gaan Prabha mahotsav Mumbai2017</li>
                <li>Suburban music circle Mumbai2016</li>
                <li>Jitendra abhisheki mahotsav pune 2014</li>
                <li>Singapore Art Festival 2018</li>
                <li>Harmonium player, research in music and mathematics.</li>
            </ul>
        </div>

        <div class="row">
            <div class="col-lg-8">
                <h6 class="fw-bold">LET’S MEET THEN.</h6>
                <h6 class="fw-bold">G.H. RAISONI SPORTS & CULTURAL FOUNDATION ORGANIZES - ONLINE SESSION</h6>
                <p>Speaker : Shri. Bhupaal Panshikar (भारत रत्न श्री रविशंकरजी तथा पं दिनकर पणशीकर, जयपुर घराना,इनके
                    शिष्य)</p>
                <p>Date : 13 <sup>th</sup> May 2020</p>
                <p>Time : 7:30 Pm</p>
                <p>Venue : Your Home at your Mobile</p>

                <h6 class="fw-bold">NOTE - LOGIN TO YOUR FACEBOOK ACCOUNTS 10 MINS BEFORE THE SESSION</h6>
                <p>Link: <a href="https://facebook.com/sgrkf/live" target="_blank">https://facebook.com/sgrkf/live</a>
                </p>

            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/programme/online-invitation-rahuljoshi1.web"
                        alt="GHRSCF">
                </div>
            </div>
        </div>


        <div class="border-line-sm"></div>

        <div class="row row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">MEDIA COVERAGE</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="media#media_classical" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">VIDEOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="videogallery" target="_blank" class="btn button--effect-1"><span>
                                YouTube link</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <iframe width="100%" height="230"
                    src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fsgrkf%2Fvideos%2F245031103399229%2F&show_text=false&width=267&t=0"
                    allowfullscreen></iframe>

            </div>
            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">PHOTOS</h4>
                        </div>
                    </div>
                    <div class="col-md-5 text-end">
                        <a href="photogallery" target="_blank" class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
